import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { CustomHttp, ConfigServerService } from '../../../../core';
import { UnidadeNegocioMercadoFilter } from '../filter';
import { UnidadeNegocioMercado } from '../unidade-negocio-mercado';

@Injectable({
    providedIn: 'root'
})
export class UnidadeNegocioMercadoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/unidadenegocio`;
    }

    /** Pesquisa todos os mercados vinculadas a unidade de negócio informada */
    search(idUnidadeNegocio: number, filter: UnidadeNegocioMercadoFilter): Observable<UnidadeNegocioMercado[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<UnidadeNegocioMercado[]>(`${this.pathApi}/${idUnidadeNegocio}/mercado`, {params});
    }
}
